import localforage from 'localforage';
import { observable, action, runInAction } from 'mobx';

const moHuring = observable({
  huringActiveShow: 'chart',
  huringList: <any>[],
});



// 展示表格还是图表
const huringActiveChange = action(async (val: string) => {
  runInAction(() => {
    moHuring.huringActiveShow = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.huringtable = val;
  localforage.setItem('humans', humanData);
});


// 展示表格还是图表
const huringShow = action(async (val: string) => {
  runInAction(() => {
    moHuring.huringActiveShow = val;
  });
});


// 获取默认数据

const getRevenueRankings = action((val: string) => {
  runInAction(() => {
    moHuring.huringList = val;
  });
});

export default moHuring;
export { huringActiveChange, getRevenueRankings, huringShow };
